// The workspace service owns signature verification and expiry. Only its known
// query fields are forwarded; destinations never come from a redirect URL.
export function signedSsoEntry(input) {
  const source = new URLSearchParams(input);
  const required = ['userId','token','timespan','partner','from','seminarId'];
  const fields = [...required,'mobile','ai','lang','landingPage','read'];
  for (const field of [...fields,'page']) {
    if (source.getAll(field).length > 1) throw new Error('登录链接包含重复参数，请重新获取签名链接。');
  }
  if (required.some(field => !source.get(field)?.trim()) || !/^\d+$/.test(source.get('seminarId')) || !/^\d+$/.test(source.get('timespan'))) {
    throw new Error('登录链接缺少有效签名参数，请重新获取登录链接。');
  }
  const params = new URLSearchParams();
  for (const [key,value] of source) if (fields.includes(key)) params.append(key,value);
  const context = Object.fromEntries([...params].filter(([key]) => !['token','timespan','read'].includes(key)));
  const requested = source.get('page');
  const page = ['hub','study','understand','decision','review','reflection'].includes(requested) ? requested : 'hub';
  return { params,context,destination:'/workspace#' + page };
}
